import {
  CALCULATE_FEE_FAILURE,
  CALCULATE_FEE_STARTED,
  CALCULATE_FEE_SUCCESS,
  CHANGE_MAIL_SERVICE_FAILURE,
  CHANGE_MAIL_SERVICE_STARTED,
  CHANGE_MAIL_SERVICE_SUCCESS,
  GET_MAIL_SERVICES_FAILURE,
  GET_MAIL_SERVICES_STARTED,
  GET_MAIL_SERVICES_SUCCESS,
  GET_SETTINGS_FAILURE,
  GET_SETTINGS_STARTED,
  GET_SETTINGS_SUCCESS,
  GET_TIME_ZONES_FAILURE,
  GET_TIME_ZONES_STARTED,
  GET_TIME_ZONES_SUCCESS,
  UPDATE_NUMBERLAND_LIMIT_FAILURE,
  UPDATE_NUMBERLAND_LIMIT_STARTED,
  UPDATE_NUMBERLAND_LIMIT_SUCCESS,
  UPDATE_TIME_ZONE_FAILURE,
  UPDATE_TIME_ZONE_STARTED,
  UPDATE_TIME_ZONE_SUCCESS,
} from "redux/ActionTypes";
import {
  calculateFeeAPI,
  calculateAdminFeeAPI,
  getBadgesAPI,
  getCitiesAPI,
  getCountriesAPI,
  getEventsAPI,
  getOccuoationAPI,
  getStatesAPI,
  getTimeZonesAPI,
  sendNewMailAPI,
  updateTimeZoneAPI,
  getMailServicesAPI,
  changeMailServiceAPI,
  getSettingsAPI,
  updateNumberlandLimitAPI,
} from "services/API/General";

export const getCountriesAction = (setCountries) => {
  return async (dispatch) => {
    try {
      let response = await getCountriesAPI();
      if (!response.error) {
        setCountries(response.data);
      } else {
      }
    } catch (error) {}
  };
};
export const getStatesAction = (setStates) => {
  return async (dispatch) => {
    try {
      let response = await getStatesAPI();
      if (!response.error) {
        setStates(response.data);
      } else {
      }
    } catch (error) {}
  };
};
export const getCitiesAction = (setCities) => {
  return async (dispatch) => {
    try {
      let response = await getCitiesAPI();
      if (!response.error) {
        setCities(response.data);
      } else {
      }
    } catch (error) {}
  };
};
export const getOccuoationAction = (setOccuoations) => {
  return async (dispatch) => {
    try {
      let response = await getOccuoationAPI();
      if (!response.error) {
        setOccuoations(response.data);
      } else {
      }
    } catch (error) {}
  };
};
export const getEventsAction = (setEvents) => {
  return async (dispatch) => {
    try {
      let response = await getEventsAPI();
      if (!response.error) {
        setEvents(response.data);
      } else {
      }
    } catch (error) {}
  };
};
// --------------------------------------------------------------------------------
export const getTimeZonesRequestAction = () => {
  return async (dispatch) => {
    dispatch(getTimeZonesStartedAction());
    try {
      let response = await getTimeZonesAPI();
      if (!response.error) {
        dispatch(getTimeZonesSuccessAction({ timeZones: response.data }));
      } else {
        dispatch(getTimeZonesFailureAction(response.data.error_description));
      }
    } catch (error) {
      dispatch(getTimeZonesFailureAction(error.error_description));
    }
  };
};
export const getTimeZonesStartedAction = () => ({
  type: GET_TIME_ZONES_STARTED,
});

export const getTimeZonesSuccessAction = (payload) => ({
  type: GET_TIME_ZONES_SUCCESS,
  payload,
});

export const getTimeZonesFailureAction = (message) => ({
  type: GET_TIME_ZONES_FAILURE,
  payload: message,
});
// --------------------------------------------------------------------------------
export const updateTimeZoneRequestAction = ({ timeZoneId, onSuccess }) => {
  return async (dispatch) => {
    dispatch(updateTimeZoneStartedAction());
    try {
      let response = await updateTimeZoneAPI({ timeZoneId });
      if (!response.error) {
        dispatch(updateTimeZoneSuccessAction({ timeZoneId }));
        onSuccess();
      } else {
        dispatch(updateTimeZoneFailureAction(response.data.error_description));
      }
    } catch (error) {
      dispatch(updateTimeZoneFailureAction(error.error_description));
    }
  };
};
export const updateTimeZoneStartedAction = () => ({
  type: UPDATE_TIME_ZONE_STARTED,
});

export const updateTimeZoneSuccessAction = (payload) => ({
  type: UPDATE_TIME_ZONE_SUCCESS,
  payload,
});

export const updateTimeZoneFailureAction = (message) => ({
  type: UPDATE_TIME_ZONE_FAILURE,
  payload: message,
});
// --------------------------------------------------------------------------------
export const getBadgesAction = ({ setBadges }) => {
  return async (dispatch) => {
    try {
      let response = await getBadgesAPI();
      if (!response.error) {
        setBadges(response.data);
      } else {
      }
    } catch (error) {}
  };
};

export const calculateFeeRequestAction = ({
  userId,
  eventId,
  walletId,
  setUserLimits,
}) => {
  return async (dispatch) => {
    dispatch(calculateFeeStartedAction());
    try {
      let response = await calculateFeeAPI({ userId, eventId, walletId });
      if (!response.error) {
        dispatch(calculateFeeSuccessAction());
        setUserLimits(response.data.fee);
      } else {
        dispatch(calculateFeeFailureAction(response.data.error_description));
      }
    } catch (error) {
      dispatch(calculateFeeFailureAction(error.error_description));
    }
  };
};
// --------------------------------------------------------------------------------
export const calculateAdminFeeRequestAction = ({
  adminId,
  eventId,
  walletId,
  setAdminLimits,
}) => {
  return async (dispatch) => {
    dispatch(calculateFeeStartedAction());
    try {
      let response = await calculateAdminFeeAPI({ adminId, eventId, walletId });
      console.log(response);
      if (!response.error) {
        dispatch(calculateFeeSuccessAction());
        setAdminLimits(response.data.fee);
      } else {
        dispatch(calculateFeeFailureAction(response.data.error_description));
      }
    } catch (error) {
      dispatch(calculateFeeFailureAction(error.error_description));
    }
  };
};

export const calculateFeeStartedAction = () => ({
  type: CALCULATE_FEE_STARTED,
});

export const calculateFeeSuccessAction = (payload) => ({
  type: CALCULATE_FEE_SUCCESS,
  payload,
});

export const calculateFeeFailureAction = (message) => ({
  type: CALCULATE_FEE_FAILURE,
  payload: message,
});
// --------------------------------------------------------------------------------
export const getMailServicesRequestAction = () => {
  return async (dispatch) => {
    dispatch(getMailServicesStartedAction());
    try {
      let response = await getMailServicesAPI();
      if (response.status === "success") {
        dispatch(getMailServicesSuccessAction({ mailServices: response.data }));
      } else {
        dispatch(getMailServicesFailureAction(response.data.error_description));
      }
    } catch (error) {
      dispatch(getMailServicesFailureAction(error.error_description));
    }
  };
};

export const getMailServicesStartedAction = () => ({
  type: GET_MAIL_SERVICES_STARTED,
});

export const getMailServicesSuccessAction = (payload) => ({
  type: GET_MAIL_SERVICES_SUCCESS,
  payload,
});

export const getMailServicesFailureAction = (message) => ({
  type: GET_MAIL_SERVICES_FAILURE,
  payload: message,
});
// --------------------------------------------------------------------------------
export const changeMailServiceRequestAction = ({ id }) => {
  return async (dispatch) => {
    dispatch(changeMailServiceStartedAction());
    try {
      let response = await changeMailServiceAPI({ id });
      if (response.status === "success") {
        dispatch(
          changeMailServiceSuccessAction({ mailServices: response.data })
        );
      } else {
        dispatch(
          changeMailServiceFailureAction(response.data.error_description)
        );
      }
    } catch (error) {
      dispatch(changeMailServiceFailureAction(error.error_description));
    }
  };
};

export const changeMailServiceStartedAction = () => ({
  type: CHANGE_MAIL_SERVICE_STARTED,
});

export const changeMailServiceSuccessAction = (payload) => ({
  type: CHANGE_MAIL_SERVICE_SUCCESS,
  payload,
});

export const changeMailServiceFailureAction = (message) => ({
  type: CHANGE_MAIL_SERVICE_FAILURE,
  payload: message,
});
// --------------------------------------------------------------------------------
export const updateNumberlandLimitRequestAction = ({ value }) => {
  return async (dispatch) => {
    dispatch(updateNumberlandLimitStartedAction());
    try {
      let response = await updateNumberlandLimitAPI({ value });
      if (response.status === "success") {
        dispatch(updateNumberlandLimitSuccessAction({ value }));
        dispatch(getSettingsRequestAction());
      } else {
        dispatch(
          updateNumberlandLimitFailureAction(response.data.error_description)
        );
      }
    } catch (error) {
      dispatch(updateNumberlandLimitFailureAction(error.error_description));
    }
  };
};

export const updateNumberlandLimitStartedAction = () => ({
  type: UPDATE_NUMBERLAND_LIMIT_STARTED,
});

export const updateNumberlandLimitSuccessAction = (payload) => ({
  type: UPDATE_NUMBERLAND_LIMIT_SUCCESS,
  payload,
});

export const updateNumberlandLimitFailureAction = (message) => ({
  type: UPDATE_NUMBERLAND_LIMIT_FAILURE,
  payload: message,
});
// --------------------------------------------------------------------------------
export const getSettingsRequestAction = () => {
  return async (dispatch) => {
    dispatch(getSettingsStartedAction());
    try {
      let response = await getSettingsAPI();
      if (response.status === "success") {
        dispatch(getSettingsSuccessAction({ settings: response.data }));
      } else {
        dispatch(getSettingsFailureAction(response.data.error_description));
      }
    } catch (error) {
      dispatch(getSettingsFailureAction(error.error_description));
    }
  };
};

export const getSettingsStartedAction = () => ({
  type: GET_SETTINGS_STARTED,
});

export const getSettingsSuccessAction = (payload) => ({
  type: GET_SETTINGS_SUCCESS,
  payload,
});

export const getSettingsFailureAction = (message) => ({
  type: GET_SETTINGS_FAILURE,
  payload: message,
});
